import { Operator } from "./operator";

export class UserAccount {
  operator: Operator;
  superUser: boolean = false;
  active: boolean = true;
  lastAcceptedUserAgreementDocumentId: number;
}